
import { create } from "zustand";
import { persist } from "zustand/middleware"; // <-- Import the persist middleware
import {
    addEdge,
    applyNodeChanges,
    applyEdgeChanges,
    MarkerType,
} from 'reactflow';

export const useStore = create(
    // Wrap the entire store in the persist middleware
    persist(
        (set, get) => ({
            nodes: [],
            edges: [],
            nodeIDs: {}, 
            
            getNodeID: (type) => {
                const newIDs = {...get().nodeIDs};
                if (newIDs[type] === undefined) {
                    newIDs[type] = 0;
                }
                newIDs[type] += 1;
                set({nodeIDs: newIDs});
                return `${type}-${newIDs[type]}`;
            },
            addNode: (node) => {
                set({
                    nodes: [...get().nodes, node]
                });
            },
            onNodesChange: (changes) => {
                set({
                    nodes: applyNodeChanges(changes, get().nodes),
                });
            },
            onEdgesChange: (changes) => {
                set({
                    edges: applyEdgeChanges(changes, get().edges),
                });
            },
            onConnect: (connection) => {
                set({
                    edges: addEdge({...connection, type: 'smoothstep', animated: true, markerEnd: {type: MarkerType.Arrow, height: '20px', width: '20px'}}, get().edges),
                });
            },
            updateNodeField: (nodeId, fieldName, fieldValue) => {
                set({
                    nodes: get().nodes.map((node) => {
                        if (node.id === nodeId) {
                            node.data = { ...node.data, [fieldName]: fieldValue };
                        }
                        return node;
                    }),
                });
            },
            // NEW: Function to wipe the canvas clean
            clearCanvas: () => {
                set({ nodes: [], edges: [], nodeIDs: {} });
            }
        }),
        {
            name: 'vectorshift-pipeline-storage', // The key used in local storage
        }
    )
);